<script>
    export let s = 4

    const style = `
        width: var(--s-${s});
        height: var(--s-${s});
    `
</script>

<div { style } />